import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  Button,
  Box,
} from "@mui/material";
import CheckImage from "../../images/checkimage.png";
import { ReactComponent as DiamondIcon } from "../../images/listdiamond.svg";
import { decryptData } from "../../crypto";
import useThankyouPageStyle from "./thankyouPageStyle";
import ExamFeedbackPopup from "./ExamFeedbackPopup";
import { loginApiWithoutPassword } from "../../services/service";
import ROUTES_NAME from "../../constants/RoutesName";
import { toast } from "react-toastify";
import Loader from "../../components/Loader";

function ThankyouPage({ handleLogin }) {
  const classes = useThankyouPageStyle();
  const navigate = useNavigate();

  const examName = decryptData(sessionStorage.getItem("exam_name"));
  const userId = sessionStorage.getItem("userId");

  const [loading, setLoading] = useState(false);

  const navigateToExamScore = () => {
    navigate("/examscore");
  };

  const handleBack = async () => {
    const data = JSON.parse(sessionStorage.getItem("userAuth"));
    setLoading(true);
    try {
      const response = await loginApiWithoutPassword(data);
      if (response.success) {
        setLoading(false);
        // toast.success("Login Successful!");
        handleLogin();
        navigate(ROUTES_NAME.DASHBOARD);
        // window.location.reload()
      }
    } catch (error) {
      setLoading(false);
      toast.error(error.message || "An error occurred");
    }
  };

  return (
    <div className={classes.container}>
      <div className={classes.imageContainer}>
        <img src={CheckImage} alt="Check" />
      </div>
      <div className={classes.heading}>
        <Typography variant="h3">
          Thank you for taking an online {examName} exam.
        </Typography>
      </div>
      {/* <div className={classes.instructionContainer}>
        <List>
          <ListItem>
            <ListItemIcon>
              <DiamondIcon />
            </ListItemIcon>
            <ListItemText primary="A proctor has closed your exam window." />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <DiamondIcon />
            </ListItemIcon>
            <ListItemText primary="If you believe this was in error, please contact Invigilator." />
          </ListItem>
          <ListItem>
            <ListItemIcon>
              <DiamondIcon />
            </ListItemIcon>
            <ListItemText primary="You may now close the application or take our survey." />
          </ListItem>
        </List>
      </div> */}
      { userId !== '4660' && (
          <Box>
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#3f50b5",
                color: "white",
                px: 4,
                py: 1.5,
                fontWeight: 500,
                borderRadius: 2,
                mt: 2,
              }}
              onClick={handleBack}
            >
              Back to dashboard
            </Button>
          </Box>
        )}
      {/* <ExamFeedbackPopup /> */}
      {/* <div>
      <Button variant="contained" color="primary" onClick={navigateToExamScore}>
        View Exam Score
      </Button>

</div> */}
      {loading && <Loader />}
    </div>
  );
}

export default ThankyouPage;
